import { useRef } from 'react';
import { openDB } from 'idb';

const dbPromise = openDB('invoice-db', 1, {
	upgrade(db) {
		if (!db.objectStoreNames.contains('invoices')) {
			db.createObjectStore('invoices', {
				keyPath: 'id',
			});
		}
	},
});

export default function useOfflineInvoice() {
	const debounceRef = useRef(null);

	// ✅ Save (create + update same record)
	const saveInvoice = (data) => {
		clearTimeout(debounceRef.current);

		debounceRef.current = setTimeout(async () => {
			const db = await dbPromise;

			await db.put('invoices', {
				id: 'invoice',
				...data,
				updatedAt: new Date(),
			});

			console.log('Draft saved/updated');
		}, 500);
	};

	// ✅ Get draft
	const getInvoice = async () => {
		const db = await dbPromise;
		return await db.get('invoices', 'invoice');
	};

	// ✅ Delete single
	const deleteInvoice = async () => {
		const db = await dbPromise;
		await db.delete('invoices', 'invoice');
	};

	// ✅ Delete ALL
	const clearAllInvoices = async () => {
		const db = await dbPromise;
		await db.clear('invoices');
	};

	return {
		saveInvoice,
		getInvoice,
		deleteInvoice,
		clearAllInvoices,
	};
}
